import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-fill text-white text-base"></i>
                </span>
                <span className="text-lg font-heading text-white tracking-wide">亚洲影视网</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                亚洲影视网提供免费电视剧在线观看服务，涵盖热门电视剧、全集免费资源，无需会员即可享受高清在线追剧体验，每日更新不断。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {navLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">国产剧</a></li>
                <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">韩剧</a></li>
                <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">日剧</a></li>
                <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">悬疑剧</a></li>
                <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">古装剧</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
              <p className="text-sm text-background-300 leading-relaxed">
                诚邀优质合作伙伴加入，共同打造更好的追剧体验。
              </p>
            </div>
          </div>

          <div className="border-t border-background-700/60 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2019-2026 亚洲影视网. 本站所有资源均来自网络，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}